let View = require('views/view')
let app = require('application')

module.exports = View.extend({
  template: require('views/templates/sport/sport'),
  events () { // On récupère ici les events de view (les event globaux) pis on ajoute les spécifiques a cette vue (SOURCE : http://stackoverflow.com/questions/9403675/backbone-view-inherit-and-extend-events-from-parent)
    return _.extend({}, View.prototype.events, {
      'click #btn-show-form-sport': 'showFormEvent',
      'click .sport-hide-form': 'hideFormEvent',
      'click .edit-sport': 'update',
      'click .delete-sport': 'delete'
    })
  },
  list () {
    let data = $('#form-pagination').serialize()
    this.hideFormEvent()

    $('#sport-list').html('<i class="fa fa-refresh fa-spin"></i> Chargement en cours...')

    app.ajax({
      url: '/sport',
      data,
      success: (...args) => this.refreshList(...args)
    })
  },
  refreshList (sports, status, xhr) {
    $('#sport-list').html(require('views/templates/sport/list')({
      sports,
      searchTerms: xhr.getResponseHeader('ps-search-term'),
      total: xhr.getResponseHeader('ps-total-row')
    })).show()

    app.initList()
  },
  update (e) {
    if (e) e.preventDefault()
    let id = $(e.currentTarget).closest('tr').data('id')
    if (id) {
      app.ajax({
        url: '/sport',
        data: { id },
        complete: app.onComplete({
          success: (res) => this.showFormEvent(res)
        })
      })
    }
  },
  showFormEvent (data) {
    $('#sport-form-ctn').empty().html(require('views/templates/sport/form')(data)).show()
    $('#btn-show-form-sport').attr('disabled', true)
    this.prepareFormEvent()
  },
  hideFormEvent (e) {
    $('#sport-form-ctn').hide().empty()
    $('#btn-show-form-sport').attr('disabled', false)
  },
  prepareFormEvent (e) {
    app.validator('sport-form', [
      { name: 'sport', display: 'Nom du sport', rules: 'required' }
    ], this.processFormEvent.bind(this))
  },
  processFormEvent (e) {
    let type = 'POST'
    if ($('#id-sport').val()) {
      type = 'PUT'
    }
    let data = $('#sport-form').serialize()
    app.ajax({
      url: '/sport',
      type,
      data,
      complete: app.onComplete({
        success: (r) => this.list(r)
      })
    })
  },
  delete (e) {
    if (e) e.preventDefault()
    let id = $(e.currentTarget).closest('tr').data('id')
    bootbox.confirm({
      message: 'Êtes vous sûr ?',
      buttons: {
        confirm: {
          label: 'Oui',
          className: 'btn-success'
        },
        cancel: {
          label: 'Non',
          className: 'btn-danger'
        }
      },
      callback: (result) => {
        if (result) {
          app.ajax({
            url: '/sport',
            type: 'DELETE',
            data: { id },
            complete: app.onComplete({
              success: (r) => {
                $('.row-sport[data-id=' + id + ']').fadeOut('slow')
              }
            })
          })
        }
      }
    })
  }

})
